/**
 * @Author: Zero
 * @Date: 2025-07-14 17:18:49
 * @Explain: 枚举
 */

// 满意度评价条件Tab
export enum ContentRatingTabEnum {
  /** 活动 */
  CAMPAIGN = 'campaign',
  /** 旅程节点 */
  JOURNEY = 'journey',
}
